import { IAsset } from "./../../../models/asset";
import { IRootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export interface IAssetsState {
    assetsList: IAsset[] | null;
    selectedAsset: IAsset | null;
    error: any;
}

export const getDefaultAssetsState = (): IAssetsState => {
    return {
        assetsList: [],
        selectedAsset: null,
        error: null,
    };
};

// initial state
const state = getDefaultAssetsState();

const namespaced: boolean = true;

export const assets: Module<IAssetsState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
